module.exports = __webpack_public_path__ + "img/logo.91480c7e.svg";